import { UnmatchedDemandStatusFilter, UnmatchedDemandSummary } from 'apis/restaurant-inquiries';
import { Button, ButtonGroup, Text } from 'design-system';
import { usePageParams } from 'hooks/use-page-params';

interface ITab {
  value: UnmatchedDemandStatusFilter;
  label: string;
  count?: number;
}

interface IStatusTabs {
  summary?: UnmatchedDemandSummary;
}

// Counts come from the summary block, which ignores the status filter — so they
// stay stable no matter which tab is active.
export const StatusTabs = ({ summary }: IStatusTabs) => {
  const { getPageParams, setPageParams } = usePageParams();
  const params = getPageParams();
  const active = (params.status as string) || 'all';

  const tabs: ITab[] = [
    { value: 'all', label: 'All', count: summary?.totalProducts },
    { value: 'no_quotes', label: 'No quotes', count: summary?.noQuotesCount },
    { value: 'quoted_no_match', label: 'Quoted, no match', count: summary?.quotedNoMatchCount },
  ];

  const onSelect = (value: UnmatchedDemandStatusFilter) => {
    const next = { ...params };
    delete next.page;
    if (value === 'all') delete next.status;
    else next.status = value;
    setPageParams(next);
  };

  return (
    <ButtonGroup isAttached variant='outline' size='sm' spacing={0}>
      {tabs.map((tab) => {
        const isActive = active === tab.value;
        return (
          <Button
            key={tab.value}
            onClick={() => onSelect(tab.value)}
            bg={isActive ? 'gray.700' : 'white'}
            color={isActive ? 'white' : 'gray.600'}
            _hover={{ bg: isActive ? 'gray.700' : 'gray.50' }}
            fontWeight='semibold'>
            {tab.label}
            {tab.count !== undefined && (
              <Text as='span' ml='6px' opacity={0.65} fontWeight='medium'>
                {tab.count}
              </Text>
            )}
          </Button>
        );
      })}
    </ButtonGroup>
  );
};
